export const SOFTLINE_API_MDE_ETIKETTENDRUCK_BEWEGUNGEN = '/v1/etikettendruck/bewegungen/entities'
export const SOFTLINE_API_MDE_ETIKETTENDRUCK_ABSCHLUSS = '/v1/etikettendruck/abschluss'
export const SOFTLINE_API_MDE_ETIKETTENDRUCK_ARTEN = '/v1/etikettendruck/arten'
export const SOFTLINE_API_MDE_ETIKETTENDRUCK_ARTIKEL = '/v1/etikettendruck/artikel/entities'
export const SOFTLINE_API_MDE_ETIKETTENDRUCK_ARTIKEL_DETAIL = 'detail'
